import { css } from 'styled-components'

export const texts = {
  texts: css`
    text-decoration: none;
  `,
}
